export const USER_INFO = 'GET_USER_INFO';
export const UPDATE_VALUE = 'UPDATE_USER_INFO';
export const getuserinfo = payload => ({
  type: USER_INFO,
  payload,
});

export const updateUserInfo = payload => ({
  type: UPDATE_VALUE,
  payload,
});

export const getWalletLimit = () => ({
  type: 'GET_WALLET_LIMIT',
});

export const updateWalletLimit = data => ({
  type: 'UPDATE_WALLET_LIMIT',
  data,
});

export const getInvoiceProduct = payload => ({
  type: 'GET_INVOICE_PRODUCT',
  payload,
});

export const setInvoiceProductList = data => ({
  type: 'SET_INVOICE_PRODUCT',
  data,
});

export const checkDasboardView = orgId => ({
  type: 'CHECK_DASHBOARD_VIEW',
  orgId,
});

// export const checkDasboardView = orgId => ({
//   type: 'CHECK_DASHBOARD_VIEW',
//   orgId,
// });

export const setDashboardView = data => ({
  type: 'SET_DASHBOARD_VIEW',
  data,
});

export const setOnboardData = data => ({
  type: 'SET_ONBOARD_SET',
  data,
});

export const activatePhyCardFromOnboardFlow = payload => ({
  type: 'ACTIVATE_CARD_ONBOARD',
  payload,
});

export const setActivatePhyCardFromOnboardFlow = data => ({
  type: 'SET_ACTIVATE_CARD_ONBOARD',
  data,
});

export const physicalCardSetTolater = data => ({
  type: 'SET_PHY_CARD_LATER',
  data,
});

export const getkycPortalLink = data => ({
  type: 'REDIRECT_TO_KYC_PORTAL',
  data,
});

export const updateOnboardMetaData = data => ({
  type: 'UPDATE_META_DATA',
  data,
});

export const logout = payload => ({
  type: 'LOGOUT',
  payload,
  loader: true,
});

export const getTutorialFlag = () => ({
  type: 'GET_TUTORIAL_FLAG',
  loader: true,
});

export const setTutorialFlag = data => ({
  type: 'SET_TUTORIAL_FLAG',
  loader: false,
  data,
});
